<template>
  <div class="topHeader" id="contxt">
    <div class="common">
      <div class="topLogo" v-on:click="clSelect">
        <dl>
          <dt></dt>
          <!-- <dd>
                            <a href="javascript:;" class="edition">
                                <span v-html="languages"></span>
                            </a>
                            <ul v-if="select=='show'">
                                <li v-bind:class="{ 'onChoose': lang== 'zh' }">
                                    <a href="javascript:;" v-on:click="langswitch('zh')">中文</a>
                                </li>
                                <li v-bind:class="{ 'onChoose': lang== 'en' }">
                                    <a href="javascript:;" v-on:click="langswitch('en')">English</a>
                                </li>
                            </ul>
                        </dd> -->
        </dl>
      </div>
      <div class="topMenu">
        <ul>
          <li>
            <router-link tag="a" to="/" :class="{'router-link-exact-active deCur': $route.path === '/' }">首页<span></span></router-link>
          </li>
          <li>
            <router-link tag="a" to="/forecast/production" :class="{'router-link-exact-active deCur': ($route.path !== '/' && $route.path !== '/about' )}"
              >乘用车产销量预测数据库<span></span
            ></router-link>
          </li>
          <li>
            <router-link tag="a" to="/about" :class="{'router-link-exact-active deCur': $route.path === '/about' }" >关于我们<span></span></router-link>
          </li>
        </ul>
      </div>
      <div class="topLogin">
        <a :href="$store.state.login_url" class="logintext" v-if="!logged_in"
          >登录 / 注册</a
        >
        <div
          v-if="logged_in"
          v-on:mouseenter="log_out = true"
          v-on:mouseleave="log_out = false"
        >
          <a href="javascript:;" id="username">{{ $store.state.user_name }}</a>
          <a href="javascript:;" class="loginout" v-show="log_out" v-on:click="logout"
            >退出</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-header",
  data: function () {
    return {
      select: "hides",
      lang: "",
      languages: "中文",
      logged_in: false,
      log_out: false,
      // userName: store.userName
    };
  },
  created() {
    // let _this = this;
    // let lang = $.cookie('gas_sales_lang');
    // if (lang == "zh-CN") {
    //     _this.languages = "中文";
    // }
    // if (lang == "en-US") {
    //     _this.languages = "English";
    // }
    this.logged_in = this.$store.state.userId === 0 ? false : true;
  },
  methods: {
    clSelect: function () {
      // this.isActive = 0;
      // if (this.select == "show") {
      //     this.select = "hides";
      // } else {
      //     this.select = "show";
      // }
    },
    langswitch: function (language) {
      var lang = language;
      console.log(lang);
      // this.lang = language;
      // if (language == 'zh') {
      //     this.languages = "中文";
      //     $.cookie('gas_sales_lang', "zh-CN", { expires: 365, path: '/' });
      //     window.location.href = window.location.href
      // } else if (language == 'en') {
      //     this.languages = "English";
      //     $.cookie('gas_sales_lang', "en-US", { expires: 365, path: '/' });
      //     window.location.href = window.location.href
      // }
    },
    logout: function () {
      this.setCookie("GASGOO_USER", "", -1);
      location.reload();
    },
    setCookie(c_name, value, expire) {
      var date = new Date();
      date.setSeconds(date.getSeconds() + expire);
      document.cookie =
        c_name +
        "=" +
        escape(value) +
        "; expires=" +
        date.toGMTString() +
        ";path=/;domain=gasgoo.com";
      // document.cookie =
      //   c_name +
      //   "=" +
      //   escape(value) +
      //   "; expires=" +
      //   date.toGMTString() +
      //   ";path=/;domain=gas.cn";
    },
  },
};
</script>
